import { render, staticRenderFns } from "./k-page.vue?vue&type=template&id=ab65a15e&lang=pug&"
import script from "./k-page.vue?vue&type=script&lang=js&"
export * from "./k-page.vue?vue&type=script&lang=js&"
import style0 from "./k-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab65a15e')) {
      api.createRecord('ab65a15e', component.options)
    } else {
      api.reload('ab65a15e', component.options)
    }
    module.hot.accept("./k-page.vue?vue&type=template&id=ab65a15e&lang=pug&", function () {
      api.rerender('ab65a15e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/blocks/k-page.vue"
export default component.exports